// eslint-disable-next-line no-shadow
export enum TransactionType {
    Sale = 'sale'
}
